/**
 * Accessible text for the issue-count badges, kept in a module with **no imports**.
 *
 * These labels are consumed by Home's card grid *and* by the sidebar's nav rows, and the
 * sidebar lives inside the `@gui/widgets/Toolbar` barrel that `useIssueCountsState` itself
 * imports. Declaring them here rather than in `useIssueCountsState` keeps the sidebar from
 * closing that loop into a genuine import cycle.
 */

/**
 * The badge is a number floating over an icon: to anything reading the accessibility tree it
 * is a bare "6" next to a link name, which reads as "Job Errors 6" and could as easily be a
 * version number or a shortcut key. Nothing else on the card says what is being counted.
 *
 * Shared by both call sites so the two cannot describe the same badge differently.
 */
export function issueCountBadgeLabel(count: number): string {
	return `${count} open ${count === 1 ? "issue" : "issues"}`;
}

/** Announced in place of the badge spinner while the count fetch is still in flight. */
export const ISSUE_COUNT_LOADING_LABEL = "Loading issue count";
